import { GlobalStyles } from '@mui/material';

const GlobalOverrides = () => (
  <GlobalStyles
    styles={{
      '*, *::before, *::after': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      'html, body': {
        height: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
      },
      'button,input,textarea,select': {
        font: 'inherit',
        background: 'none',
        border: 'none',
        outline: 'none',
        appearance: 'none',

        '&:-webkit-autofill': {
          boxShadow: '0 0 0 1000px white inset !important',
          transition: 'background-color 5000s ease-in-out 0s',
        },
      },
      'ul, ol': {
        listStyle: 'none',
      },
      a: {
        textDecoration: 'none',
        color: 'inherit',
      },
    }}
  />
);

export default GlobalOverrides;
